import axios from 'axios';
import { BASE_URL, HEADERS } from "../../src/Utils/UrlUtils";

export function getAllQuestions(userEmail, password) {
    const URI = "/assesment/getAllQuestions";
    return axios.get(BASE_URL + URI + '/' + userEmail + '/' + password, HEADERS());
}

export function validateCandidateDetails(candidateEmail, testCode) {
    const URI = "/assesment/isValidCandidate";

    const data = {
        "email": candidateEmail,
        "secretCode": testCode
    }
    return axios.post(BASE_URL + URI, data);

}

export function updateStartSubmitAssesmentFlag(assesmentId, startOrUpdateFlag) {
    const URI = "/assesment/updateStartSubmit/" + assesmentId + "/" + startOrUpdateFlag;
    return axios.get(BASE_URL + URI, HEADERS());
}

export function tabChangeDetected(assesmentId) {
    const URI = "/assesment/tabChangeDetected/" + assesmentId;
    return axios.get(BASE_URL + URI, HEADERS());

}